<template>
  <q-page class="q-pa-xs-xs q-pa-sm-sm q-pa-md-md">
    <div class="text-h6 text-bold" :class="$q.dark.mode ? '' : 'text-primary '">
      Settings
    </div>
    <!-- NOTIFICATION SETTINGS -->
    <NotificationSettings
      v-if="
        Object.keys(notificationSettingsData).length > 0 &&
        settingDialog == false
      "
      :notificationData="notificationSettingsData"
      :customStocks="customStocks"
      @save="(e) => ((notificationSettingsData = e), onClickSave())"
    />

    <!-- EMAIL SETTINGS -->
    <div class="row q-mb-md">
      <q-card flat bordered class="col-12 q-pa-md q-pa-xs-xs">
        <q-card-section class="text-subtitle1 text-bold">
          <div class="text-h" :class="$q.dark.mode ? '' : 'text-primary '">
            Email Settings
          </div>
        </q-card-section>
        <!-- <q-card-section class="q-ma-md q-ma-xs-xs"> -->
        <q-list class="row">
          <q-item class="col-12">
            <q-item-section>
              <q-input
                dense
                v-model="inputEmail"
                color="primary"
                type="email"
                label="Email Address"
                :disable="profile.is_email_verified"
              >
                <template v-slot:append>
                  <!-- <q-btn
                    v-if="profile.email != inputEmail"
                    round
                    dense
                    flat
                    class="q-mr-md"
                    color="grey"
                    @click="inputEmail = profile.email"
                  /> -->
                  <q-btn
                    v-if="!isEmailVerify"
                    dense
                    outline
                    :label="
                      profile.email != inputEmail && profile.email != null
                        ? 'update email'
                        : profile.is_email_verified
                        ? 'verified'
                        : 'get OTP'
                    "
                    :color="
                      profile.email != inputEmail
                        ? 'primary'
                        : profile.is_email_verified
                        ? 'green'
                        : 'primary'
                    "
                    @click="emailVerify()"
                  />
                </template>
                <template v-if="isEmailVerify" v-slot:after>
                  <vue-countdown
                    v-if="isCounting"
                    :time="60000"
                    @end="isCounting = false"
                    v-slot="{ totalSeconds }"
                    >{{ totalSeconds }} s</vue-countdown
                  >
                  <q-btn
                    v-else
                    round
                    dense
                    flat
                    icon="refresh"
                    @click="onReload()"
                  />
                </template>
              </q-input>
            </q-item-section>
          </q-item>

          <q-item class="col-12" v-show="isEmailVerify">
            <q-item-section>
              <q-input dense v-model="otp" label="Enter OTP">
                <template v-slot:append>
                  <q-btn
                    dense
                    outline
                    text-color="secondary"
                    label="verify email"
                    @click="verifyOTP()"
                  />
                  <q-btn
                    dense
                    outline
                    text-color="red"
                    label="Cancel"
                    @click="$router.go()"
                  />
                </template>
              </q-input>
            </q-item-section>
          </q-item>
        </q-list>
        <!-- </q-card-section> -->
      </q-card>
    </div>

    <!-- <div class="row q-mb-md">
      <q-card flat bordered class="col-12">
        <q-card-section class="text-h6 q-ma-md">
          <div class="text-primary text-h6">Referral</div>
        </q-card-section>
        <q-card-section v-if="!Referrals.status" class="q-ma-md">
          <q-item-section>
            <q-input
              dense
              v-model="inputRefer"
              type="tel"
              label="Referral Number"
              :rules="[(val) => !!val || 'Number is missing']"
            >
              <template v-slot:append>
                <q-btn
                  dense
                  outline
                  color="primary"
                  label="Refer By"
                  @click="referBy()"
                />
              </template>
            </q-input>
          </q-item-section>
        </q-card-section>
        <q-card-section v-else>
          <div class="text-h8 text-grey">
            You have already used your Referral Code
          </div>
        </q-card-section>
      </q-card>
    </div> -->

    <!-- EDIT PROFILE -->
    <div class="row q-mb-md" v-if="settingDialog == false">
      <q-card flat bordered class="col-12">
        <q-card-section class="text-subtitle1 text-bold">
          <div class="text-h" :class="$q.dark.mode ? '' : 'text-primary '">
            Edit Profile
          </div>
        </q-card-section>
        <q-list class="row q-ml-md">
          <q-item class="col-12">
            <q-item-section>
              <q-input dense v-model="profile.first_name" label="First Name" />
            </q-item-section>
          </q-item>
          <q-item class="col-12">
            <q-item-section>
              <q-input dense v-model="profile.last_name" label="Last Name" />
            </q-item-section>
          </q-item>
        </q-list>
        <q-card-actions class="q-ma-md q-pa-md" align="center">
          <q-btn
            push
            :color="$q.dark.mode ? 'grey-7' : 'primary'"
            align="center"
            label="Update Info"
            @click="updateUserInfo"
            class="text-capitalize text-white"
            style="min-width: 130px"
            dense
          ></q-btn>
        </q-card-actions>
      </q-card>
    </div>

    <!-- CHANGE PASSWORD -->
    <div class="row q-mb-md" v-if="settingDialog == false">
      <q-card flat bordered class="col-12 q-px-md">
        <q-card-section class="text-subtitle1 text-bold">
          <div class="text-h" :class="$q.dark.mode ? '' : 'text-primary '">
            Change Password
          </div>
        </q-card-section>
        <q-card-section class="q-mx-lg">
          <q-list class="row">
            <q-item class="col-md-12 col-sm-12 col-xs-12">
              <q-item-section>
                <q-input
                  dense
                  :type="isCurrPwd ? 'password' : 'text'"
                  v-model="userPasswords.current_password"
                  label="Current Password"
                >
                  <template v-slot:prepend>
                    <q-icon name="password" />
                  </template>

                  <template v-slot:append>
                    <q-icon
                      :name="isCurrPwd ? 'visibility_off' : 'visibility'"
                      class="cursor-pointer"
                      @click="isCurrPwd = !isCurrPwd"
                    />
                  </template>
                </q-input>
              </q-item-section>
            </q-item>
            <q-item class="col-md-12 col-sm-12 col-xs-12">
              <q-item-section>
                <q-input
                  dense
                  :type="isNewPwd ? 'password' : 'text'"
                  v-model="userPasswords.new_password"
                  label="New Password"
                  :rules="newPasswordRule"
                >
                  <template v-slot:prepend>
                    <q-icon name="password" />
                  </template>

                  <template v-slot:append>
                    <q-icon
                      :name="isNewPwd ? 'visibility_off' : 'visibility'"
                      class="cursor-pointer"
                      @click="isNewPwd = !isNewPwd"
                    />
                  </template>
                </q-input>
              </q-item-section>
            </q-item>

            <q-item class="col-md-12 col-sm-12 col-xs-12">
              <q-item-section>
                <q-input
                  dense
                  :type="isConPwd ? 'password' : 'text'"
                  v-model="userPasswords.confirm_password"
                  label="Confirm Password"
                  :rules="confirmPasswordRule"
                >
                  <template v-slot:prepend>
                    <q-icon name="password" />
                  </template>

                  <template v-slot:append>
                    <q-icon
                      :name="isConPwd ? 'visibility_off' : 'visibility'"
                      class="cursor-pointer"
                      @click="isConPwd = !isConPwd"
                    />
                  </template>
                </q-input>
              </q-item-section>
            </q-item>
          </q-list>
        </q-card-section>
        <q-card-actions class="q-ma-md q-pa-md" align="center">
          <q-btn
            dense
            push
            color="primary"
            align="center"
            label="Change Password"
            @click="updateUserPassword"
            class="text-capitalize text-white"
          ></q-btn>
        </q-card-actions>
      </q-card>
    </div>

    <!-- DELETE ACCOUNT -->
    <DeleteAccount
      v-if="settingDialog == false"
      :hasPackage="hasPackage"
      :profile="profile"
      @deleteAccount="deleteAccount($event)"
      @undoDelete="undoDelete()"
    />
  </q-page>
</template>

<script>
import { api } from "boot/axios";

import { ref, onMounted, computed, reactive } from "vue";
import { useRouter } from "vue-router";

import { useQuasar, LocalStorage } from "quasar";
import useAccounts from "src/use/accounts";
import useMembership from "src/use/membership";
import { useStore } from "vuex";
import VueCountdown from "@chenfengyuan/vue-countdown";
import NotificationSettings from "src/components/settings/NotificationSettings.vue";
import DeleteAccount from "src/components/settings/DeleteAccount/DeleteAccount.vue";
import { Dialog } from "quasar";

export default {
  name: "SettingsPage",
  props: {
    settingDialog: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VueCountdown,
    NotificationSettings,
    DeleteAccount,
  },

  setup(props, context) {
    const emitedData = ref([]);
    const $q = useQuasar();
    const otp = ref("");
    const profile = ref({
      first_name: "",
      last_name: "",
      email: "",
      del_request: "",
    });
    const userPasswords = ref({});
    const inputEmail = ref("");
    const userProfile = ref({});
    const $store = useStore();
    const requestToDelete = ref({ force: false });
    const deleteRequestForm = ref(null);
    let deleteUser = ref(null);

    const callWhoAmI = () => {
      if ($store.state.authenticate.isAuthenticated) {
        if ($store.state.accounts.whoAmI) {
          profile.value = $store.state.accounts.whoAmI;
          inputEmail.value = $store.state.accounts.whoAmI.email;
        } else {
          $store.dispatch("accounts/whoAmI").then((res) => {
            profile.value = res;
            inputEmail.value = res.email;
          });
        }
      }
    };
    callWhoAmI();
    const {
      updateWhoAmI,
      whoAmI,
      updatePassword,
      deleteAccountRequest,
      undoAccountDelete,
      clearUserCache,
    } = useAccounts();
    const {
      postReferralNumber,
      getReferralStatus,
      getNotificationSettings,
      postNotificationSettings,
    } = useMembership();
    const router = useRouter();
    const inputRefer = ref("");
    const showreferral = ref(true);

    const isCounting = ref(false);
    const isEmailVerify = ref(false);
    const Referrals = ref({});

    const isCurrPwd = ref(true);
    const isConPwd = ref(true);
    const isNewPwd = ref(true);
    const hasPackage = ref(false);
    const notificationSettingsData = ref([]);
    const customStocks = ref(false);
    const { authenticate, packages } = $store.state;
    if (authenticate.isAuthenticated) {
      if (packages.packageStatus?.current_package) {
        hasPackage.value = true;
      } else {
        $store.dispatch("packages/getPackageStatus").then(() => {
          if (packages.packageStatus?.current_package) hasPackage.value = true;
        });
      }
    }

    const deleteAccount = (event) => {
      let payload = {
        remarks: event.remarks || "",
        forced: event.force,
      };
      deleteAccountRequest(payload)
        .then(() => {
          $q.notify({
            type: "positive",
            message: "Your account deletion process has started",
          });
          $store.dispatch("authenticate/logout");
          router.push({ name: "Dashboard" });
        })
        .catch((error) => {
          const { data } = error.response;
          $q.notify({
            type: "warning",
            icon: "warning",
            message: data.message || "Something went wrong",
          });
        });
    };

    const undoDelete = () => {
      undoAccountDelete().then(() => {
        $q.notify({
          type: "positive",
          message: "Your account deletion process canceled",
        });

        whoAmI().then((res) => {
          profile.value = res.data;
          inputEmail.value = res.data.email;
        });
      });
    };
    function loadNotificationSetting() {
      getNotificationSettings().then((res) => {
        notificationSettingsData.value = res.data[0];
        customStocks.value = notificationSettingsData.value.custom_stocks;
      });
    }

    const update = (value, key) => {
      const excludeKeys = {
        master: ["id"],
        custom_stocks: [
          "id",
          "master",
          "offer_email",
          "general_notifications",
          "stop_loss_profit_target",
          "circuit_setup",
          "bulk_transaction",
        ],
      };

      if (excludeKeys[key]) {
        if (!value) {
          Object.keys(notificationSettingsData.value).forEach((k) => {
            if (!excludeKeys[key].includes(k)) {
              notificationSettingsData.value[k] = false;
            }
          });
          notificationSettingsData.value[key] = false;
        }
      }
    };

    function onClickSave() {
      postNotificationSettings(notificationSettingsData.value)
        .then((res) => {
          loadNotificationSetting();
          $q.notify({
            type: "positive",
            icon: "done_all",
            message: "Notification Saved Successful",
          });
        })
        .catch((error) => {
          $q.notify({
            type: "negative",
            icon: "error",
            message: "Save Notification Failed",
          });
        });
    }

    function referBy() {
      if (inputRefer.value == profile.value.phone_number) {
        $q.notify({
          title: "Error",
          message: "You can't refer yourself",
          color: "negative",
        });
      } else {
        postReferralNumber(inputRefer.value)
          .then((res) => {
            $q.notify({
              title: "Success",
              message: "You have successfully referred",
              color: "positive",
            });
          })
          .catch((error) => {
            $q.notify({
              title: "Error",
              message: "You have already used a referral number ",
              color: "negative",
            });
          });
      }
    }

    getReferralStatus().then((res) => {
      Referrals.value = res.data;
    });

    const updateUserInfo = () => {
      updateWhoAmI({
        first_name: profile.value.first_name,
        last_name: profile.value.last_name,
      })
        .then((res) => {
          whoAmI().then((res) => {
            profile.value = res.data;
            LocalStorage.set("whoAmI", res.data);
          });
          $q.notify({
            type: "positive",
            icon: "done_all",
            message: "User Update Successful",
          });
        })
        .catch((error) => {
          $q.notify({
            type: "negative",
            icon: "error",
            message: "User Update Failed",
          });
        });
    };

    const updateUserEmail = () => {
      return new Promise((resolve, reject) => {
        updateWhoAmI({
          email: inputEmail.value,
        })
          .then((res) => {
            whoAmI().then((res) => {
              profile.value = res.data;
              inputEmail.value = profile.value.email;
              $q.notify({
                type: "positive",
                icon: "done_all",
                message: "Email Update Successful",
              });
              resolve();
            });
          })
          .catch((error) => {
            $q.notify({
              type: "negative",
              icon: "error",
              message: "Email Update Failed",
            });
            reject();
          });
      });
    };
    const updateUserPassword = () => {
      updatePassword(userPasswords.value)
        .then((res) => {
          userPasswords.value = {};
          $q.notify({
            type: "positive",
            message: "Password Changed Successful",
          });
          $store.dispatch("authenticate/logout").then(() => {
            $store.commit("packages/updatePackageStatus", []);
            router.push({ path: "/login" });
            $q.notify({
              type: "positive",
              message: "Logging Out",
            });
          });
        })
        .catch((error) => {
          const { message } = error.response.data.message;
          $q.notify({
            type: "negative",
            message: message,
          });
        });
    };

    const confirmPasswordRule = computed(() => [
      (val) =>
        val === userPasswords.value.new_password ||
        "Password confirmation failed. Please type the same password in both fields",
    ]);
    const newPasswordRule = computed(() => [
      (val) =>
        val !== userPasswords.value.current_password ||
        "New password cannot be same as old password",
    ]);

    const emailVerify = async () => {
      // await updateUserEmail().then(() => {
      if (profile.value.is_email_verified === false) {
        // isEmailVerify.value = true;
        // isCounting.value = true;
        api
          .post("/accounts/email/otp/", {
            email: inputEmail.value,
          })
          .then((res) => {
            isEmailVerify.value = true;
            isCounting.value = true;
            // if (res.status === 200) {
            $q.notify({
              type: "positive",
              message: "OTP sent to your email",
            });
            // }
          })
          .catch((error) => {
            const { response } = error;
            $q.notify({
              type: "negative",
              message: response.data.email,
            });
          });
      }
      // });
    };

    const verifyOTP = async () => {
      useAccounts().clearUserCache();
      useMembership().clearMembershipCache();
      api
        .post("/accounts/verify/email/", {
          email: inputEmail.value,
          otp: otp.value,
        })
        .then((res) => {
          $store.dispatch("accounts/whoAmI").then((res) => {
            LocalStorage.set("whoAmI", res);
          });
          $q.notify({
            type: "positive",
            message: "Email verified",
          });
          isEmailVerify.value = false;
          isCounting.value = false;
          profile.value.is_email_verified = true;
          context.emit("closeModel", true);
        })
        .catch((error) => {
          $q.notify({
            type: "negative",
            message: "Invalid OTP",
          });
        });
    };

    const onReload = async () => {
      isCounting.value = true;
      emailVerify();
    };

    onMounted(() => {
      loadNotificationSetting();
    });

    return {
      hasPackage,
      deleteAccount,
      undoDelete,
      customStocks,
      $q,
      emitedData,
      deleteUser,
      // postDeleteDialog,
      deleteRequestForm,
      requestToDelete,
      router,
      onReload,
      emailVerify,
      verifyOTP,
      updateUserInfo,
      updateUserEmail,
      otp,
      inputEmail,
      profile,
      userProfile,
      isEmailVerify,
      isCounting,

      model: ref(null),

      referBy,
      inputRefer,
      Referrals,
      showreferral,
      notificationSettingsData,
      update,
      onClickSave,

      userPasswords,
      updateUserPassword,
      isCurrPwd,
      isNewPwd,
      isConPwd,

      confirmPasswordRule,
      newPasswordRule,
    };
  },
};
</script>
